import { useQuery } from "@tanstack/react-query";
import { useMemo } from "react";
import { getLockQueryKey, getLocksQueryKey } from "../queryClient";
import { getLock, getLocks } from "../lib/lock";
import { Lock } from "../common/types/lock";
import { getLockDate } from "../helpers/lock";

export function useLockDate(entityId?: number | null) {
    const { data: locks } = useQuery({
        queryKey: getLockQueryKey(entityId),
        queryFn: () => getLock(entityId),
        refetchOnMount: false,
    });

    return useMemo(() => getLockDate(locks), [locks]);
}

export function useLockList(entityIds: number[]): Lock[] {
    const { data: locks } = useQuery({
        queryKey: getLocksQueryKey(entityIds),
        queryFn: () => getLocks(entityIds),
        refetchOnMount: false,
    });

    return locks ?? [];
}
